import React from "react";

function classNames(...inputs) {
  const out = [];
  const visit = (x) => {
    if (x == null || x === false) return;
    const t = typeof x;
    if (t === "string" || t === "number") {
      const s = String(x).trim();
      if (s) out.push(s);
      return;
    }
    if (Array.isArray(x)) { x.forEach(visit); return; }
    if (t === "object") {
      for (const k in x) {
        if (!Object.prototype.hasOwnProperty.call(x, k)) continue;
        if (x[k]) out.push(k);
      }
      return;
    }
  };
  inputs.forEach(visit);
  return out.join(" ");
}

const LoanInputPanel = ({
  principal,
  setPrincipal,
  rate,
  setRate,
  tenure,
  setTenure,
  currentMonth,
  setCurrentMonth,
  isFlat,
  setIsFlat,
  effectiveRate,
  formatCurrency,
}) => (
  <div className="bg-white dark:bg-neutral-800 rounded-2xl shadow-lg p-8 sticky top-24">
    <h2 className="text-xl font-semibold mb-6 text-neutral-800 dark:text-neutral-100">Loan Details</h2>

    {/* Interest Type Toggle */}
    <div className="mb-6 p-4 rounded-xl bg-gradient-to-r from-blue-50 to-indigo-50 ring-1 ring-blue-200">
      <div className="flex items-center justify-between mb-2">
        <label className="text-sm font-medium text-neutral-700">Interest Type</label>
        <button
          onClick={() => setIsFlat(!isFlat)}
          className={classNames(
            "relative inline-flex h-6 w-11 items-center rounded-full transition",
            isFlat ? "bg-orange-600" : "bg-green-600"
          )}
        >
          <span className="sr-only">Toggle interest type</span>
          <span
            className={classNames(
              "inline-block h-4 w-4 transform rounded-full bg-white transition",
              isFlat ? "translate-x-6" : "translate-x-1"
            )}
          />
        </button>
      </div>
      <div className="text-sm">
        <span className="font-semibold">{isFlat ? "Flat Rate" : "Reducing Balance"}</span>
        <p className="text-xs text-neutral-600 mt-1">
          {isFlat
            ? "Interest calculated on full principal for entire tenure (used by some NBFCs)"
            : "Interest on outstanding balance only (used by all banks)"}
        </p>
      </div>
      {isFlat && (
        <div className="mt-2 p-2 bg-amber-100 rounded-lg">
          <p className="text-xs text-amber-800">
            ⚠️ Flat {rate}% ≈ {effectiveRate.toFixed(1)}% reducing rate
          </p>
        </div>
      )}
    </div>

    <div className="space-y-6">
      <div>
        <div className="flex justify-between items-center mb-2">
          <label className="text-sm font-medium text-neutral-700">
            Loan Amount
          </label>
          <span className="text-sm font-semibold text-green-600">
            {formatCurrency(principal)}
          </span>
        </div>
        <input
          type="range"
          min="100000"
          max="50000000"
          step="100000"
          value={principal}
          onChange={(e) => setPrincipal(Number(e.target.value))}
          className="w-full h-2 bg-neutral-200 rounded-lg appearance-none cursor-pointer slider"
        />
        <div className="flex justify-between text-xs text-neutral-500 mt-1">
          <span>₹1L</span>
          <span>₹5Cr</span>
        </div>
      </div>

      <div>
        <div className="flex justify-between items-center mb-2">
          <label className="text-sm font-medium text-neutral-700">
            Interest Rate
          </label>
          <span className="text-sm font-semibold text-orange-600">
            {rate}%
          </span>
        </div>
        <input
          type="range"
          min="6"
          max="15"
          step="0.1"
          value={rate}
          onChange={(e) => setRate(Number(e.target.value))}
          className="w-full h-2 bg-neutral-200 rounded-lg appearance-none cursor-pointer slider"
        />
        <div className="flex justify-between text-xs text-neutral-500 mt-1">
          <span>6%</span>
          <span>15%</span>
        </div>
      </div>

      <div>
        <div className="flex justify-between items-center mb-2">
          <label className="text-sm font-medium text-neutral-700">
            Loan Tenure
          </label>
          <span className="text-sm font-semibold text-blue-600">
            {tenure} years
          </span>
        </div>
        <input
          type="range"
          min="1"
          max="30"
          step="1"
          value={tenure}
          onChange={(e) => setTenure(Number(e.target.value))}
          className="w-full h-2 bg-neutral-200 rounded-lg appearance-none cursor-pointer slider"
        />
        <div className="flex justify-between text-xs text-neutral-500 mt-1">
          <span>1 year</span>
          <span>30 years</span>
        </div>
      </div>

      <div className="pt-4 border-t border-neutral-200">
        <div className="flex justify-between items-center mb-2">
          <label className="text-sm font-medium text-neutral-700">
            Current Month
          </label>
          <span className="text-sm font-semibold text-purple-600">
            Month {currentMonth}
          </span>
        </div>
        <input
          type="range"
          min="1"
          max={tenure * 12}
          step="1"
          value={currentMonth}
          onChange={(e) => setCurrentMonth(Number(e.target.value))}
          className="w-full h-2 bg-neutral-200 rounded-lg appearance-none cursor-pointer slider"
        />
        <div className="flex justify-between text-xs text-neutral-500 mt-1">
          <span>Month 1</span>
          <span>Month {tenure * 12}</span>
        </div>
      </div>
    </div>
  </div>
);

export default LoanInputPanel;
